import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Button, Tooltip } from '@hotjar/hotsauce';

import { ErrorBoundary } from '@hotjar/error-handler';

const HighlightButton = styled(Button)<{ isActive: boolean }>`
  ${(props) => props.isActive && `background-color: ${tokens.color.bg_active};`}
  border-radius: ${tokens.radius.m};
`;

export interface ToggleButtonProps {
  onToggle: () => void;
  isActive: boolean;
  isDisabled?: boolean;
  disabledText?: string;
}

export function ToggleButton({
  isActive,
  isDisabled,
  disabledText,
  onToggle,
}: ToggleButtonProps): JSX.Element {
  const { t } = useTranslation();

  const buttonText = isActive
    ? t('highlights:heatmaps.create.hide-highlights')
    : t('highlights:heatmaps.create.show-highlights');

  return (
    <ErrorBoundary squadSentryTag="workflow">
      <Tooltip text={isDisabled ? disabledText || buttonText : buttonText}>
        <div>
          <HighlightButton
            isActive={isActive}
            kind="ghost"
            onClick={onToggle}
            icon="lightbulb"
            size="s"
            isDisabled={isDisabled}
            aria-label={buttonText}
          >
            {buttonText}
          </HighlightButton>
        </div>
      </Tooltip>
    </ErrorBoundary>
  );
}
